var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[_c('p',[_vm._v("中国质量协会 版权所有 未经授权请勿转载任何图文或建立镜像")]),_vm._v(" "),_c('p',[_vm._v("制作单位：中国质量协会网络中心")]),_vm._v(" "),_c('p',[_vm._v("Copyright©2003-2008 All rights reserved 京ICP备05018279号-1 京公网安备 110102000185")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81239e5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bottom.vue
// module id = OnU7
// module chunks = 1